import React from 'react';
import PropTypes from 'prop-types';

class LoadBeacon extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        {this.props.loadBeaconUrl &&
        <div className="sponsored-products-beacon-wrapper beacon-wrapper">
          <img src={this.props.loadBeaconUrl} alt="beacon" />
        </div>
        }
      </React.Fragment>
    );
  }
}

LoadBeacon.displayName = 'LoadBeacon';
LoadBeacon.propTypes = {
  loadBeaconUrl: PropTypes.string
};

LoadBeacon.defaultProps = {
  loadBeaconUrl: null
};

export default LoadBeacon;
